import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.createPayment.types";
import { contractHasRentPaymentOrder, getNavigationTitle, } from "./schema.createPayment.utils";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        return {
            required: [EField.OwnerPaymentMethod],
            properties: (_a = {},
                _a[EField.Header + "7"] = {
                    default: undefined,
                },
                _a[EField.Subtitle] = {
                    default: undefined,
                },
                _a[EField.OwnerPaymentMethod] = {
                    default: getValue(EField.OwnerPaymentMethod, initialValues, defaultValues),
                    // @ts-ignore
                    options: [
                        {
                            id: "DIRECT",
                            value: getLocalizedText("payment.payment_order.owner_payment_method.direct"),
                        },
                        {
                            id: "FROM_RENT",
                            value: getLocalizedText("payment.payment_order.owner_payment_method.from_rent"),
                            disabled: !contractHasRentPaymentOrder(extraData, defaultValues),
                        },
                    ],
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:title": getLocalizedText("payment.payment_order.owner_payment_method.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "7"] = {
            "ui:field": ERentioFormField.SectionHeader,
            getTitle: function () {
                return getLocalizedText("payment.payment_order.owner_payment_method.heading");
            },
        },
        _a[EField.Subtitle] = {
            "ui:field": ERentioFormField.HelpInfo,
            subtitle: getLocalizedText("payment.payment_order.owner_payment_method.info"),
        },
        _a[EField.OwnerPaymentMethod] = {
            "ui:field": ERentioFormField.InlineSelect,
            title: getLocalizedText("payment.payment_order.owner_payment_method.label"),
            formatSummary: function (input) {
                return input
                    ? getLocalizedText("payment.payment_order.owner_payment_method.".concat(input.toLowerCase()))
                    : "";
            },
        },
        _a);
};
